module.exports = __webpack_public_path__ + "img/vs.49083648.png";